import React from "react";
import { Empty, Spin } from "antd";

const EmptyLoader = ({ loading, isDataAvailable }) => (
  <>
    {loading && (
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spin />
      </div>
    )}
    {!isDataAvailable && !loading && (
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Empty />
      </div>
    )}
  </>
);

export default EmptyLoader;
